<template>
  <p
    v-if="config"
    :id="config.id"
    class="summary-item"
  >
    <span
      class="has-text-weight-bold"
      :class="{ 'has-text-warning': showWarning }"
    >
      {{ config.label }}:
    </span>
    &nbsp;
    {{ configValue }}
  </p>

  <p
    v-if="item"
    :id="id"
    class="summary-item"
  >
    <span
      class="has-text-weight-bold"
      :class="{ 'has-text-warning': showWarning }"
      v-html="label + ':'"
    />
    &nbsp;
    {{ item.value }}
  </p>

  <p
    v-if="value"
    :id="id"
    class="summary-item"
    style="margin-top: 0.5em;">
    <span
      class="has-text-weight-semibold"
      v-html="label + ':'"
    />
    {{ value }}
    <span
      v-if="units"
      v-html="units"
    />
  </p>
</template>

<script>
export default {
  props: {
    id: String,
    label: String,
    item: Object, // needs `ok` and `value` attributes
    value: {
      type: String,
      default: '',
    },
    units: {
      type: String,
      default: '',
    },
    config: {
      type: Object,
      required: false,
    },
  },
  computed: {
    // Simulation.vue - parseValue()
    configValue() {
      let ret = '';
      if (this.config.type && this.config.type === 'result') {
        // result page
        ret = this.config.value || '-';
      } else if (this.config.type && (this.config.type === 'radio' || this.config.type === 'select')) {
        // radio or select
        const el = this.config.options.find((element) => element.value === this.config.model.value);
        ret = el.label || '';
      } else if (this.config.type && this.config.type === 'checkbox') {
        // checkbox
        const values = [];
        Object.keys(this.config.model.value).forEach((key) => {
          if (this.config.model.value[key]) {
            const el = this.config.options.find((element) => element.value === key);
            values.push(el.label);
          }
        });
        ret = values;
      } else if (this.config.type && this.config.type === 'date') {
        // date
        const val = this.config.model.value;
        ret = val ? new Date(val).toLocaleDateString() : '';
      } else if (this.config.vmin || this.config.vmax || this.config.vpositive || this.config.vinteger) {
        // number
        ret = Number(this.config.model.value);
      } else {
        // other
        ret = this.config.model.value;
      }
      if (Array.isArray(ret)) {
        // array
        ret = ret.join(', ');
      }
      return ret;
    },
    showWarning() {
      if (this.config) {
        return this.config.model != null && this.config.model.ok != null ? !this.config.model.ok : false;
      }
      return (this.item.ok !== undefined && !this.item.ok);
    },
  },
};
</script>

<style scoped>
p.summary-item {
  min-height: 2em;
  margin-top: 0.5em;
}
/*
p.summary-item > span {
  min-width: 11em;
  display: inline-block;
}
*/
</style>
